import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20scenery%20illustration%2C%20peaceful%20reading%20nook%20with%20warm%20ambient%20light%2C%20bookshelves%20and%20cozy%20atmosphere%2C%20soft%20golden%20sunlight%20streaming%20through%20window%2C%20artistic%20and%20dreamy%20mood%2C%20professional%20digital%20art%2C%20cinematic%20wide%20shot%2C%20warm%20coral%20and%20amber%20tones&width=1920&height=800&seq=cta-bg-2026&orientation=landscape"
        alt="开始阅读韩漫"
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-foreground-900/60"></div>

      <div className="relative z-10 max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-xl">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            准备好开始
            <br />
            您的韩漫之旅了吗
          </h2>
          <p className="mt-6 text-sm md:text-base text-background-200/90 leading-relaxed">
            数千部精选韩国漫画等你来发现，下拉式阅读让你沉浸其中无法自拔。
          </p>
          <div className="mt-8">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 bg-background-50 hover:bg-background-100 text-foreground-900 px-8 py-3.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
            >
              立即探索
              <span className="w-6 h-6 flex items-center justify-center bg-primary-500 rounded-full">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}